export const BASE_SERVER = 'https://' + 'www.eshikkha.org' + '/prod/public/v1.0.0/public-content?type=';
